import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Secured',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      title: 'Privacy Protected',
      description: 'GDPR compliant'
    },
    {
      icon: 'CheckCircle',
      title: 'Verified Platform',
      description: 'Trusted by thousands'
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2 text-center sm:text-left">
            <div className="flex items-center justify-center w-8 h-8 bg-success/10 rounded-full flex-shrink-0">
              <Icon 
                name={feature?.icon} 
                size={16} 
                className="text-success"
              />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">
                {feature?.title}
              </p>
              <p className="text-xs text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityBadges;